module.exports = __webpack_public_path__ + "static/inspect-mode-cover-1440c5855f0d1f2fb80b355f25c49351.png";